var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type === 'wells')?_c('TaxToggleWells',{attrs:{"taxToggle":_vm.taxToggle}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }